import { request } from "@/utils/request";

// 访问统计接口
export function visitStatistics() {
  return request({
    method: "post",
    url: "/api/patrol/sys/v1/visit-statistics",

  });
}